const Alarm = class {
  constructor(id = null, data) {
    this.id = id;
    if (id && data) {
      this.data = data;
    } else {
      const date = new Date();
      this.data = { label: '', hour: date.getHours(), minutes: date.getMinutes(), enabled: true, repeat: 0 };
    }
  }

  get time() {
    return { hour: this.data.hour, minutes: this.data.minutes };
  }

  get formatted() {
    const hour = this.data.hour.toString().padStart(2, '0');
    const minutes = this.data.minutes.toString().padStart(2, '0');
    return `${hour}:${minutes}`;
  }


  get label() {
    return 'label' in this.data ? this.data.label : '';
  }

  get hour() {
    return this.data.hour;
  }

  set hour(data) {
    this.data.hour = data;
  }

  get minutes() {
    return this.data.minutes;
  }

  set minutes(data) {
    this.data.minutes = data;
  }

  get enabled() {
    return this.data.enabled;
  }

  set enabled(data) {
    this.data.enabled = data;
  }

  get repeat() {
    return this.data.repeat;
  }

  get json() {
    return {
      label: this.label,
      enabled: this.enabled,
      time: this.time,
      repeat: this.repeat,
    };
  }

  static isValid(data) {
    if (typeof data === 'object' && data !== null) {
      return 'enabled' in data && 'hour' && data && 'minutes' in data && 'repeat' in data;
    }
    return false;
  }

  static toFB(data) {
    const { time, ...tmp } = data;
    return Object.assign(tmp, { hour: time.hour, minutes: time.minutes });
  }

  toggleEnabled() {
    this.enabled = !this.enabled;
  }
};

export default Alarm;



// WEBPACK FOOTER //
// ./src/store/models/alarm.js